export const parameters = {
  input: event => {
    const isExchange = event.target?.name?.includes('exchangeType')

    const customEvent = {
      value: event.target.value,
      id: event.target.id,
      name: event.target.name?.split('-')[0],
      tagName: event.target.tagName,
      className: event.target.className,
    }

    if (isExchange) {
      customEvent.itemPosition = event.target?.name?.split('-')[1]
    }

    return customEvent
  },
  change: event => {
    return {
      value: event.target.value,
      id: event.target.id,
      name: event.target.name?.split('-')[0],
      tagName: event.target.tagName,
      className: event.target.className,
    }
  },
  click: event => {
    const parent = event?.target?.parentNode

    if (event?.target?.role === 'option' || parent?.role === 'option') {
      return {
        value: event?.target?.dataset?.value || parent?.dataset?.value,
        tagName: 'OPTION',
        text: event?.target?.innerText,
      }
    }

    if (event.target.tagName === 'BODY') {
      const menu = document.getElementById('menu-')
      const name = menu?.getAttribute('name')
      const isExchange = ['variants', 'exchangeType'].includes(name?.split('-')[0])
      if (menu && name) {
        const customEvent = {
          name: name?.split('-')[0],
          tagName: 'SELECT',
        }

        if (isExchange) {
          customEvent.itemPosition = name?.split('-')[1]
        }

        return customEvent
      }
    }

    if (event.target.id || event.target.name) {
      return {
        value: event.target.value,
        id: event.target.id,
        name: event.target.name?.split('-')?.[0],
        tagName: event.target.tagName,
        text: event.target.innerText,
        className: event.target.className,
      }
    }
  },
  copy: event => {
    return {
      id: event.target.id,
      name: event.target.name?.split('-')[0],
      value: event.target.value,
    }
  },
  paste: event => {
    return {
      id: event.target.id,
      name: event.target.name?.split('-')[0],
      value: event.target.value,
    }
  },
}

export const eventsToListen = ['click', 'change', 'input', 'copy', 'paste']

export const maxBufferedEvents = 500
